import type { Event as UserEvent } from "@tandemdiabetes/sugarmate-api-react-client"
import type { RxCollection } from "rxdb"
import { useRxCollection } from "rxdb-hooks"
import { CollectionKey } from "src/types"

export function useUserEventsCollection(): RxCollection<UserEvent> | null {
  return useRxCollection<UserEvent>(CollectionKey.UserEvent)
}
